import type { ThemeFontWeight, ThemeTextSizes } from '@rover/kibble/styles/themeTypes';
import { Logger } from '@rover/rsdk/src/modules/Logging';

import { Props as LinkProps } from '../../core/Link/Link';

/** Props for TextWithSingleInlineLink component */
export type TextWithSingleInlineLinkProps = Omit<LinkProps, 'children' | 'as'> & {
  /** Text with link placeholder: "text before <0>link text</0> text after" */
  paragraphText: string;
  /** Text size preset */
  size?: ThemeTextSizes;
  /** Click handler for the link */
  onClick?: () => Promise<void> | void;
  /** Font weight for the link (defaults to text fontWeight) */
  linkFontWeight?: ThemeFontWeight | ThemeFontWeight[];
  /** Render as Paragraph instead of Text */
  asParagraph?: boolean;
};

export const isTaggedParagraphText = (paragraphText: string): boolean => {
  // Regex here checks to make sure <0> and </0> are being passed in the string
  const regex = /^.*?<0>.*?<\/0>.*$/;
  return regex.test(paragraphText);
};

export const validateParagraphText = (paragraphText: string): void => {
  if (!isTaggedParagraphText(paragraphText)) {
    Logger.error(
      new Error(
        `Invalid paragraphText structure starting with: "${paragraphText.slice(
          0,
          10
        )}". It should contain "<0>link or highlighted text</0>" with optional text before and/or after.`
      )
    );
  }
};
